import { requireAuthOrTokenOrRedirectToGame } from '../guards.js';

export const path = '/glp-won/:gameId/success';
export const component = 'GlpWonSuccess';
export const thunk =
  ({ ctx } = {}) =>
  (dispatch, getState) =>
    requireAuthOrTokenOrRedirectToGame(dispatch, getState, ctx);
